export async function getDateStatus(booking:Booking, type:string = 'booking') {
    console.log('get-date-status.ts')
    const reactAppData = window.react_data.api_url ? window.react_data : {api_url:''};
    if(process.env.NODE_ENV === 'development') {
        return {'date_available':true, 'loan_car_available':false}
    } else {
        let data = new FormData();
        data.append('action', 'react_data');
        data.append('call', 'booking date status');
        data.append('type', type)
        data.append('booking', JSON.stringify(booking));

        return await fetch(reactAppData.api_url, {body:data, method:'post'})
            .then(res => res.json())
            .then(
                (result) => {
                    return result
                },
                (error) => {
                    return {error:error}
                }
            );
    }
}
